<script>
    import {onMount} from 'svelte'
    import StationInfo from '../components/StationInfo.svelte'    
    import List from '../components/List.svelte'    
    import {language } from '@src/languages'
    import {getResource } from '@src/service'
    import routerManager from '@src/router/router'


    const router = routerManager.getRouter('default')

    let loading = true
    let params = null
    let items = []
    let meta = { skip:0,limit:30}
    
    
    
    
    onMount(()=>{        
        
        params = router.getState().params            
        if(params && Object.keys(params).length > 0){               
            localStorage.setItem('search_params',JSON.stringify(params))
        }else{
            params = JSON.parse(localStorage.getItem('search_params'))
        }        
        let qs = {q:params.query,skip:meta.skip,limit:meta.limit}        
        getResource('stations',qs)
        .subscribe(p => {
            p.then(data=>{
                loading = false;
                items = data.data
                meta = data.meta
                
            })
        })

    })
        
    function hasMore(meta){
        
        if(typeof(meta) != 'undefined'){
            if(meta.total == 0) return false 
            if(meta.limit == 0) return false                        
            return  (meta.skip / meta.limit) <  Math.floor(meta.total / meta.limit);
        }else{
            return false
        }
    }    
    
    function more(){
        let qs = {q:params.query,skip:meta.skip + meta.limit ,limit:meta.limit}        
        getResource('stations',qs)
        .subscribe(p => {
            p.then(data=>{
                loading = false;
                items = [...items,...data.data]
                meta = data.meta
                
            })
        })
    }
    
</script>
<div class="h-full w-full overflow-hidden ">
    <List {items} let:item={item} >        
        <div slot="header" class="w-full p-4 sticky top-0 bg-white">
            <h1 class="w-full text-center shadow-md"> {$language.label_total_results} : { meta.total  || 0}</h1>
        </div>
        <StationInfo station={item} />
        <div slot="footer">
            {#if hasMore(meta)}
                <button class="shadow-md w-full mb-4 p-4 text-center text-green-600 text-2xl"
                    on:click={more} >
                    {$language.label_more}
                </button>
            {/if}
        </div>
    </List>
</div>
<style>
</style>
